import React, { useEffect, useRef, useState } from "react";
import { listarEmpresasNomes } from "../services/api";

// Autocomplete de empresa: sugere as já cadastradas (evita duplicatas e "gruda" na reputação existente).
// onChange(nome, empresaId|null) — empresaId vem preenchido quando o usuário SELECIONA uma da lista.
export default function EmpresaAutocomplete({ value, onChange, inputCls, placeholder }) {
  const [empresas, setEmpresas] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [ativo, setAtivo] = useState(-1); // índice destacado p/ navegação por teclado (a11y)
  const ref = useRef(null);

  useEffect(() => { listarEmpresasNomes().then(setEmpresas).catch(() => {}); }, []);
  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const q = (value || "").trim().toLowerCase();
  // Com texto: filtra. Sem texto (recém-aberto): lista as empresas (mais citadas primeiro), estilo Reclame Aqui.
  const filtradas = q.length >= 1
    ? empresas.filter((e) => e.nome.toLowerCase().includes(q))
    : [...empresas].sort((a, b) => (b.totalDenuncias || 0) - (a.totalDenuncias || 0));
  const sugestoes = filtradas.slice(0, 8);
  const exato = empresas.some((e) => e.nome.toLowerCase() === q);

  return (
    <div className="relative" ref={ref}>
      <input
        className={inputCls}
        value={value}
        autoComplete="off"
        role="combobox"
        aria-expanded={aberto && sugestoes.length > 0}
        aria-controls="empresa-sugestoes"
        aria-activedescendant={ativo >= 0 ? `empresa-opt-${ativo}` : undefined}
        aria-label="Nome da empresa"
        placeholder={placeholder || "Digite e selecione (ou cadastre uma nova)"}
        onChange={(e) => { onChange(e.target.value, null); setAberto(true); setAtivo(-1); }}
        onFocus={() => setAberto(true)}
        onKeyDown={(e) => {
          if (!aberto || sugestoes.length === 0) return;
          if (e.key === "ArrowDown") { e.preventDefault(); setAtivo((i) => Math.min(i + 1, sugestoes.length - 1)); }
          else if (e.key === "ArrowUp") { e.preventDefault(); setAtivo((i) => Math.max(i - 1, 0)); }
          else if (e.key === "Enter" && ativo >= 0) { e.preventDefault(); const s = sugestoes[ativo]; onChange(s.nome, s.id); setAberto(false); setAtivo(-1); }
          else if (e.key === "Escape") { setAberto(false); setAtivo(-1); }
        }}
      />
      {aberto && sugestoes.length > 0 && (
        <ul id="empresa-sugestoes" role="listbox" className="absolute z-30 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg max-h-56 overflow-auto">
          {sugestoes.map((e, idx) => (
            <li
              key={e.id}
              id={`empresa-opt-${idx}`}
              role="option"
              aria-selected={idx === ativo}
              onMouseEnter={() => setAtivo(idx)}
              onClick={() => { onChange(e.nome, e.id); setAberto(false); setAtivo(-1); }}
              className={`cursor-pointer px-3 py-2 text-sm flex items-center justify-between gap-2 ${idx === ativo ? "bg-gray-100" : "hover:bg-gray-100"}`}
            >
              <span className="text-gray-800">{e.nome}</span>
              <span className="text-xs text-gray-400 shrink-0">{(e.totalDenuncias || 0) + (e.totalElogios || 0)} relato(s)</span>
            </li>
          ))}
        </ul>
      )}
      {q.length >= 2 && !exato && (
        <p className="mt-1 text-xs text-gray-400">Nenhuma selecionada — será criada a empresa "{value}".</p>
      )}
    </div>
  );
}
